<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.pa-2(style="background-color: var(--v-basic600T16)")
        v-row(no-gutters)
          v-col.shrink.mr-3.pt-1
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              eva-icon.ma-1(name="close" :fill="$vuetify.theme.themes[$theme].basic800" height="30")
          v-col.align-self-center
            p.mb-0.h6.basic800--text
              span(v-if="member") {{ $t('edit_member') }}
              span(v-else) {{ $t('add_member') }}

      v-card-text.pa-0
        v-form(ref="form")
          v-card.px-4.pt-4(style="box-shadow:none")
            div(v-if="company.primary_owner !== member.id")
              p.mb-2.label.basic600--text.text-uppercase {{ $t('role') }}
              v-select(v-model="inviteRole" :items='memberRoles' item-value="id" item-text="name" dense outlined height="40" background-color="basic200")
            div
              p.mb-2.label.basic600--text.text-uppercase {{$t('phone.label')}}
              y-phone-input.my-4(v-model="phoneNo")

      v-card-actions.pa-2.pb-4
        v-spacer
        v-btn(text @click='showModal = false' depressed height=32)
          .button-Aa-small.primary400--text| {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading")
          div(v-if="member")
            .button-AA-small.basic100--text| {{ $t('save') }}
          div(v-else)
            .button-AA-small.basic100--text| {{ $t('add')}}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AddMember',
  props: ['open', 'parentMember', 'company'],
  data: () => ({
    staffId: null,
    inviteRole: null,
    phoneNo: null,
    emailExtentions: [],
    emailSearch: null,
    isLoading: false,
    memberRoles: [
      {
        name: 'Admin',
        id: 1
      },
      {
        name: 'Salesperson',
        id: 2
      },
      {
        name: 'Agent',
        id: 3
      }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      is_selected: [(v) => v !== null || 'Item is required'],
      has_quantity: [(v) => !!v || 'Item is required', (v) => v != 0|| 'Item is required'],
      valid_email: [v => !!v || 'Email is required', v => /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address'],
      phone: [
        v => !!v || 'Phone Number is required',
        v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ],
    }
  }),
  computed: {
    member: {
      get() {
        return this.parentMember
      },
      set(newValue) {
        this.$emit('update:parentMember', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    phoneSanitized () {
      let phone = this.phoneNo.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
      if (phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      return phone
    },
    computedEmailExtentions () {
      return this.emailExtentions
    }
  },
  mounted () {
    if (this.member) {
      this.firstName = this.member.user.first_name
      this.lastName = this.member.user.last_name
      const memberRole = this.memberRoles.filter((obj) => {
        return obj.name == this.member.role
      })
      this.inviteRole = memberRole[0].id
      this.email = this.member.user.email
      this.phoneNo = this.member.phone
    }
  },
  watch: {
    emailSearch (val) {
      if (val.includes('@')) return
      this.emailExtentions = [`${val}@gmail.com`, `${val}@yahoo.com`, `${val}@yahoo.com.my`, `${val}@hotmail.com`]
      if (val.length === 0) this.emailExtentions = []
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = {
        role: this.inviteRole,
        phone: this.phoneSanitized
      }
      if (this.member) {
        this.$axios.patch(`/members/${this.member.id}/`, params)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.member_edited')])
          this.member = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.$axios.post(`/members/`, params)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.member_added')])
          this.$emit('added', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.container-image {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "first_name": {
      "label": "First Name",
      "placeholder": "Write first name here"
    },
    "last_name": {
      "label": "Last Name",
      "placeholder": "Write last name here"
    },
    "staff_id": {
      "label": "Staff ID",
      "placeholder": "Write staff ID (if any)"
    },
    "email": {
      "label": "Email",
      "placeholder": "Write email here"
    },
    "phone": {
      "label": "Mobile Phone",
      "placeholder": "Phone Number"
    }
  },
  "id": {
    "first_name": {
      "label": "Nama Depan",
      "placeholder": "Tulis Nama Depan di sini"
    },
    "last_name": {
      "label": "Nama Belakang",
      "placeholder": "Tulis Nama Belakang di sini"
    },
    "staff_id": {
      "label": "ID Staf",
      "placeholder": "Tulis ID Staf (jika ada)"
    },
    "email": {
      "label": "Email",
      "placeholder": "Tulis email di sini"
    },
    "phone": {
      "label": "Nomor HP",
      "placeholder": "Nomor HP"
    }
  }
}
</i18n>